import './styles/blast_draft.scss';
import { AppContext } from '../../Context.tsx';
import { useEffect, useContext, useState } from 'react';
import { IonDateString } from '../../i-components/IonDate.tsx';
import { useNavigate } from 'react-router-dom';

//controllers
import DatabaseInterfaceController from '../../i-controllers/DatabaseInterfaceController.tsx';

//classes
import BlastHistory from '../../i-classes/blastHistory.tsx';

//muis
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

interface Props {

}

const BlastDraft: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const [drafts, SetDrafts] = useState<BlastHistory[]>([] as BlastHistory[]);
    //controllers
    const database = new DatabaseInterfaceController(appContext);
    //router objs
    const navigate = useNavigate();

    //watchers
    //test
    // useEffect(() => {
    //     console.log('checkDrafts: ' + JSON.stringify(drafts));
    // }, [drafts]);

    //initialize
    useEffect(() => {
        FetchDrafts();
    }, []);

    //watch for databaseResultAction
    useEffect(() => {
        if (
            appContext.databaseActionModeQueue.length > 0
            && appContext.databaseResultAction != null
        ) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();

                if (!JSON.stringify(res).includes('_false')) {
                    switch (mode) {
                        case 'fetchBlastDrafts':
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res;
                            }

                            const _drafts = [] as BlastHistory[];
                            resObjs.map((resObj: any) => {
                                _drafts.push(new BlastHistory(
                                    resObj['autoID'],
                                    resObj['receiver_email_address'],
                                    resObj['email_subject'],
                                    resObj['email_content'],
                                    resObj['email_template'],
                                    resObj['datetime_created'],
                                    resObj['blasted']
                                ));
                            });
                            SetDrafts([..._drafts]);
                            break;
                        case 'deleteDraft':
                            alert('Successfully deleted 1 email draft.');
                            FetchDrafts();
                            break;
                    }
                } else {
                    console.log('ExecuteDatabaseResultActionErr: ' + mode + ' ' + res);

                    if (mode == 'deleteDraft') {
                        alert('Fail to delete draft, draft not deleted.');
                    }
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case "fetchBlastDrafts":
                case 'deleteDraft':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnEditDraftClicked = (draft: BlastHistory) => {
        navigate("/admin/event_blast/" + draft.autoID);
    }
    const OnRemoveDraftClicked = (draft: BlastHistory) => {
        if (window.confirm("Are you sure to remove the selected draft: " + draft.email_subject + ' ?')) {
            ProceedDeleteDraft(draft);
        } else {

        }
    }

    //exe functions
    const SortDraftsByDateTimeCreate = (drafts: BlastHistory[]) => {
        const sorted: BlastHistory[] = [];

        drafts.map((draft: BlastHistory) => {
            console.log('checkDateTime: ' + draft.datetime_created);
            let isSorted = false;
            sorted.map((sort: BlastHistory, i: number) => {
                if (
                    !isSorted && draft.datetime_created && sort.datetime_created
                    && draft.datetime_created > sort.datetime_created
                ) {
                    sorted.splice(i, 0, draft);
                    isSorted = true;
                }
            });

            if (!isSorted)
                sorted.push(draft);
        })

        return sorted;
    }
    const ProceedDeleteDraft = (draft: BlastHistory) => {
        database.Queue('deleteDraft', [
            ['deleteDraft', 'true'],
            ['draftID', draft.autoID]
        ]);
    }
    const FetchDrafts = () => {
        database.Queue('fetchBlastDrafts', [
            ['fetchBlastDrafts', 'true']
        ]);
    }

    return (
        <div className='BlastDraft'>
            <span className='title'>Blast Drafts</span>
            <div className='header-row'>
                <span className='row-lbl ex-1'>No.</span>
                <span className='row-lbl ex-2'>Subject</span>
                <span className='row-lbl ex-3'>Date Time Created</span>
                <span className='row-lbl ex-4'>Operation</span>
            </div>
            {
                drafts.length > 0 ?
                    <div className='scroll'>
                        {
                            SortDraftsByDateTimeCreate(drafts).map((draft: BlastHistory, i: number) => {
                                return (
                                    <div className='scroll-row'>
                                        <span className='row-txt ex-1'>{(i + 1).toString()}</span>
                                        <span className='row-txt ex-2'>{draft.email_subject}</span>
                                        <span className='row-txt ex-3'>{IonDateString(draft.datetime_created)}</span>
                                        <div className='sub-row ex-4'>
                                            <button className='row-btn' onClick={() => OnEditDraftClicked(draft)}><EditIcon /></button>
                                            <button className='row-btn' onClick={() => OnRemoveDraftClicked(draft)}><DeleteIcon /></button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <span className='norecord-lbl'>No records found.</span>
            }
        </div>
    )
}
export default BlastDraft;